import { useController, useFormContext } from 'react-hook-form';
import { Radio, RadioChangeEvent } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { SelectionModel } from '../types';

interface SelectionTypeProps {
  lineId?: number | null;
}

enum SelectionTypeEnum {
  Line = 'Line',
  Selection = 'Selection',
  All = 'All'
}

export const SelectionType = ({ lineId: defaultLineId }: SelectionTypeProps) => {
  const { control } = useFormContext<SelectionModel>();
  const { field: { value: lineId, onChange: setLineId } } = useController({ control, name: 'lineId' });
  const { field: { value: selected, onChange: setSelected } } = useController({ control, name: 'selected' });

  const handleChange = useCallback((event: RadioChangeEvent) => {
    const { value } = event.target;
    if (value === SelectionTypeEnum.Selection) {
      setLineId(null);
      setSelected(true);
    } else if (value === SelectionTypeEnum.All) {
      setLineId(null);
      setSelected(false);
    } else if (defaultLineId) {
      setLineId(defaultLineId);
      setSelected(false);
    }
  }, [defaultLineId, setLineId, setSelected]);

  const value = useMemo(() => {
    if (lineId) {
      return SelectionTypeEnum.Line;
    } else if (selected) {
      return SelectionTypeEnum.Selection;
    } else {
      return SelectionTypeEnum.All;
    }
  }, [lineId, selected]);

  return (
    <Radio.Group onChange={handleChange} value={value} className="bulkPartRequestSelectionTypeControl">
      <Radio value={SelectionTypeEnum.Line}>Apply to line</Radio>
      <Radio value={SelectionTypeEnum.Selection}>Apply to selected</Radio>
      <Radio value={SelectionTypeEnum.All}>Apply to all</Radio>
    </Radio.Group>
  );
};
